import { useEffect } from 'react'

// https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
// According to the specification, to show the confirmation dialog an event
// handler should call preventDefault() on the event. However note that not all
// browsers support this method, and some instead require the event handler to
// implement one of two legacy methods:
// - assigning a string to the event's returnValue property
// - returning a string from the event handler.
const handleBeforeUnload = (event: BeforeUnloadEvent) => {
  event.preventDefault()
  event.returnValue = ''

  return ''
}

export const useBeforeUnload = (when: boolean) => {
  useEffect(() => {
    if (when) {
      window.addEventListener('beforeunload', handleBeforeUnload)
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [when])
}
